import { render, staticRenderFns } from "./CoLinkPreview.vue?vue&type=template&id=75871e27&scoped=true&"
import script from "./CoLinkPreview.vue?vue&type=script&lang=ts&"
export * from "./CoLinkPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CoLinkPreview.vue?vue&type=style&index=0&id=75871e27&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75871e27",
  null
  
)

export default component.exports